export default __webpack_public_path__ + "static/media/chantilly8.7fe7ee92.jpg";